// Blog Carousel Swiper - Wait for Swiper to be available
function initializeBlogCarousel() {
    if (typeof Swiper === 'undefined') {
        setTimeout(initializeBlogCarousel, 100);
        return;
    }

    const blogCarouselSwiper = new Swiper('.blog-carousel-swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        pagination: {
            el: '.blog-carousel-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.blog-carousel-next',
            prevEl: '.blog-carousel-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

    // Pause autoplay on hover
    const swiperContainer = document.querySelector('.blog-carousel-swiper');
    if (swiperContainer) {
        swiperContainer.addEventListener('mouseenter', function () {
            blogCarouselSwiper.autoplay.stop();
        });

        swiperContainer.addEventListener('mouseleave', function () {
            blogCarouselSwiper.autoplay.start();
        });
    }

    console.log('Blog carousel initialized successfully');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBlogCarousel);
} else {
    setTimeout(initializeBlogCarousel, 100);
}
